import Vue from 'vue'
import VueRouter from 'vue-router'
import allRouter from './modules-config'
let appInfo = require('../../../../AppInfo');
Vue.use(VueRouter);
const initRouter = () => {
  const routerParam = {
    mode: 'hash',
    base:appInfo.PUBLIC_PATH,
    routes: [
      {
        path: '/',
        name: 'Login',
        component: (resolve) => require(['@/main/login.vue'], resolve)
      },
      {
        path: '/password',
        name:'password',
        component: (resolve) => require(['@/main/password.vue'], resolve),
        meta: { title: '修改密码' }
      },
      {
        path: '/index',
        component: (resolve) => require(['@/main/index.vue'], resolve),
        children: [
          {
            path: '',
            name: 'Home',
            component: (resolve) => require(['@/main/common/include/_right.vue'], resolve),
            meta: { title: '首页', icon: 'icon-monitor' }
          },
          ...allRouter.routes,
          {
            path: '/*',
            component: (resolve) => require(['@/main/common/errors/404.vue'], resolve),
            meta: { title: '正在开发中' }
          }
        ]
      }
    ]
  };
  let router = new VueRouter(routerParam);
  router.beforeEach((to, from, next) => {
    // HeyUI.$LoadingBar.start();
    if (to.meta && to.meta.title) {
      document.title = to.meta.title
    }
    next()
  });
  router.afterEach(() => {
    // HeyUI.$LoadingBar.success();
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
    let layoutContent = document.querySelector('.h-layout-content');
    if (layoutContent) {
      layoutContent.scrollTop = 0
    }
  });
  return router
};
export default initRouter
